import { type FC } from 'react';
import { cva } from 'class-variance-authority';
import cn from 'classnames';

import { H1 } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { capImages } from './config';

import css from './styles.module.scss';

import usdPng from '/img/icons/usd-v2.png';
import usdWebp from '/img/icons/usd-v2.webp';

const rewardVariant = cva('', {
  variants: {
    variant: {
      1: css.first,
      2: css.second,
      3: css.third,
    },
  },
});

interface RewardForPlaceProps {
  className?: string;
  place: 1 | 2 | 3;
  reward: number | string;
}

const RewardForPlace: FC<RewardForPlaceProps> = ({
  place,
  reward,
  className,
}) => {
  const capImage = capImages[place];

  return (
    <div
      className={cn(
        css.rewardForPlace,
        rewardVariant({ variant: place }),
        className,
      )}
    >
      <span className={css.place}>{place}</span>
      <Picture {...capImage} />
      <H1
        weight="extrabold"
        className="absolute left-1/2 -translate-x-1/2 -bottom-[10px]"
      >
        ${reward}
      </H1>
      <Picture
        className={cn(
          'absolute size-[32px] bottom-3',
          place === 1 ? '-right-1' : '-right-2',
        )}
        img={usdPng}
        webp={usdWebp}
        alt="uds"
      />
    </div>
  );
};

export { RewardForPlace };
